import { Component, OnInit } from '@angular/core';
import { environment } from 'apps/property-sell/src/environments/environment';
import { removeTrailingSlash } from '@classifieds-sell/shared';

@Component({
    selector: 'property-not-found',
    templateUrl: './property-not-found.component.html',
    styleUrls: ['./property-not-found.component.scss']
})
export class PropertyNotFoundComponent implements OnInit {
    tradeMeUrl: string;

    ngOnInit(): void {
        this.tradeMeUrl = removeTrailingSlash(environment.trademeUrl);
    }
}
